import { CssBaseline, List, ListItem, ListItemText } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React, { useEffect, useState } from "react";
import NumberFormat from "react-number-format";
import { useLocalizedName } from "../../../globals/langHelpers";
import { FormattedMessage, useIntl, defineMessages } from "react-intl";

const useStyles = makeStyles((theme) => ({
    labelCss: {
        fontSize: 12,
        color: "#555555",
        padding: "0px 0px 0px 0px",
    },
    labelValueCss: {
        fontSize: 16,
        color: "#222222",
        padding: "0px 0px 0px 0px",
    },
    root: {
        paddingTop: 0,
        paddingBottom: 0,
    },
    formContents: {
        display: "flex",
        flexDirection: "column",
    },
}));
function LabourerViewForm(props) {
    const intl = useIntl();
    const { getLocalizedName } = useLocalizedName();
    const classes = useStyles();
    const [fieldList, setFieldList] = useState([]);
    useEffect(() => {
        let contracts = [];
        let skills = [];
        props.fields.forEach((field) => {
            if (field.key === "contracts") {
                if (props.technician && props.technician.contracts.length > 0)
                    props.technician.contracts.filter((c) => c).map((cn) => contracts.push(cn.description));
                field.value = contracts;
            } else if (field.key === "skills") {
                if (props.technician && props.technician.skills.length > 0)
                    props.technician.skills.filter((s) => s).map((skill) => skills.push(getLocalizedName({ object: skill })));
                field.value = skills;
            } else field.value = props.technician[field.key];
        });
        setFieldList(props.fields);
    }, [props.technician]);
    return (
        <>
            <CssBaseline />
            <List className={classes.formContents}>
                {fieldList.map((field, index) => {
                    return (
                        <>
                            <ListItem key={index} classes={{ root: classes.root }}>
                                <ListItemText
                                    key={intl.formatMessage(field.label)}
                                    primary={intl.formatMessage(field.label)}
                                    classes={{ primary: classes.labelCss }}></ListItemText>
                            </ListItem>
                            {Array.isArray(field.value) ? (
                                <>
                                    {field.value.map((value, index) => {
                                        return (
                                            <ListItem key={value + index} classes={{ root: classes.root }}>
                                                <ListItemText primary={value}></ListItemText>
                                            </ListItem>
                                        );
                                    })}
                                </>
                            ) : (
                                <ListItem
                                    key={field.value + index}
                                    classes={{
                                        primary: classes.labelValueCss,
                                        root: classes.root,
                                    }}>
                                    {field.key === "phone" ? (
                                        <div>
                                            <NumberFormat value={field.value} displayType={"text"} format={"(###) ### ####"} />
                                        </div>
                                    ) : (
                                        <ListItemText primary={field.value}></ListItemText>
                                    )}
                                </ListItem>
                            )}
                        </>
                    );
                })}
            </List>
        </>
    );
}
export default LabourerViewForm;
